import { useApiPost } from '../api/Api.hooks';

export function useGetAvailableProcessors() {
  const { data, isLoading, error, post } = useApiPost<any>('dragonpay/GetAvailableProcessors');
  return { response: data, isLoading, error, getProcessors: post };
}